var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import MeetingType from "../models/MeetingType";
import { getXSRF } from "../src/Services/Shared/FetchService";
export default class MeetingTypeService {
    /**
     * Fetches meeting types.
     *
     * @param {boolean} active - When provided, only returns meeting types with the specified value
     * for the 'active' field.
     * @param campaign - The appointment campaign that brought the user to this page
     */
    static fetchMeetingTypes(active = null, campaign = null) {
        return __awaiter(this, void 0, void 0, function* () {
            let url = "/aviso/meetingType/getMeetingTypes?a=1";
            if (active != null) {
                url += `&active=${active}`;
            }
            if (campaign != null) {
                url += `&campaign=${campaign}`;
            }
            const response = yield fetch(url, {
                credentials: "include",
            });
            const types = yield response.json();
            return types.data.map(MeetingTypeService.mapMeetingTypeFromJson);
        });
    }
    /**
     * Fetches a meeting type from the server.
     *
     * @param {number} meetingTypeId - The ID of the meeting type to load.
     */
    // @ts-expect-error - TS7006 - Parameter 'meetingTypeId' implicitly has an 'any' type.
    static fetchMeetingType(meetingTypeId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/meetingType/getMeetingType?id=${meetingTypeId}`, {
                credentials: "include",
            });
            const responseJson = yield response.json();
            return MeetingTypeService.mapMeetingTypeFromJson(responseJson.data);
        });
    }
    // @ts-expect-error - TS7006 - Parameter 'jsonObject' implicitly has an 'any' type.
    static mapMeetingTypeFromJson(jsonObject) {
        const meetingType = new MeetingType();
        meetingType.id = jsonObject.id;
        meetingType.name = jsonObject.name;
        meetingType.additionalInfo = jsonObject.additionalInfo;
        meetingType.durationMinutes = jsonObject.durationMinutes;
        meetingType.requiresLocation = jsonObject.requiresLocation;
        meetingType.active = jsonObject.active;
        meetingType.isSelected = false;
        meetingType.createdBy = jsonObject.createdBy;
        meetingType.createdDate = jsonObject.createdDate;
        meetingType.modifiedBy = jsonObject.modifiedBy;
        meetingType.modifiedDate = jsonObject.modifiedDate;
        return meetingType;
    }
    /**
     * Creates a new meeting type.
     *
     * @param {MeetingType} meetingType - The meeting type to create.
     */
    static createMeetingType(meetingType) {
        return __awaiter(this, void 0, void 0, function* () {
            // For now, the method on the server is the same for creating and editing.
            return MeetingTypeService.updateMeetingType(meetingType);
        });
    }
    /**
     * Saves an existing meeting type.
     *
     * @param {MeetingType} meetingType - The meeting type to save.
     */
    static updateMeetingType(meetingType) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch("/aviso/meetingType/save", {
                credentials: "include",
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify(meetingType),
            });
            return response.json();
        });
    }
    /**
     * Deletes a meeting type.
     *
     * @param {number} id - The ID of the meeting type to delete.
     */
    static deleteMeetingType(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/meetingType/delete?id=${id}`, {
                credentials: "include",
                headers: {
                    "X-XSRF-TOKEN": getXSRF(),
                },
            });
            return response.json();
        });
    }
}
